import React from 'react';
import { FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { IRulesetSchemaOperator } from '../../../types/ruleset-types';

interface OperatorSelectProps {
  value: string;
  operators: IRulesetSchemaOperator[];
  onChange: (operator: string) => void;
  disabled?: boolean;
}

const OperatorSelect: React.FC<OperatorSelectProps> = ({
  value,
  operators,
  onChange,
  disabled = false,
}) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value);
  };

  // Ensure operators is an array
  const operatorList = Array.isArray(operators) ? operators : [];

  return (
    <FormControl size="small" sx={{ width: '100%', minWidth: 0 }}>
      <Select
        value={value}
        onChange={handleChange}
        disabled={disabled || operatorList.length === 0}
        displayEmpty
        variant="outlined"
        data-cy="select-condition-operator"
        sx={{ width: '100%', fontSize: '13px' }}
        MenuProps={{
          PaperProps: {
            sx: { maxHeight: 300 },
          },
        }}
      >
        <MenuItem value="">
          <em>Select operator...</em>
        </MenuItem>
        {operatorList.map((op) => (
          <MenuItem key={op.name} value={op.name} data-cy={`operator-option-${op.name}`}>
            {op.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default OperatorSelect;
